const getProfilePictureSource = function (
  anonymousProfile,
  profilePictureName
) {
  let imageLocation = "/images/";
  let imageName = "placeholder.PNG";
  if (!anonymousProfile && profilePictureName !== undefined) {
    imageName = profilePictureName;
  }
  return imageLocation + imageName;
};

export default getProfilePictureSource;
